var n=function(n){var t=typeof n;return null!=n&&("object"==t||"function"==t)};export{n as i};
//# sourceMappingURL=isObject-27c2f2cf.js.map
